export function bigDecimalWithCommas(string, minimumFractionDigits = 6) {
  // Ideally this would be tighter controlled, but it is legacy
  // eslint-disable-next-line no-eq-null
  if (string == null) return null;
  return Number.parseFloat(string).toLocaleString(undefined, {
    minimumFractionDigits,
  });
}
